module.exports = __webpack_public_path__ + "static/media/smiley.6ff3c8b5.png";